import Vapi from '@borisp/vuex-rest-api'
import { getOptimisticDelete, payloadToState } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    tvStations: [],
    timezones: [],
    allTvStations: [],
    tvStationsMetadata: {},
    tvStation: {}
  }
})
  .get({
    action: 'getTvStations',
    property: 'tvStations',
    queryParams: true,
    path: '/tv-stations/',
    onSuccess: payloadToState('tvStations')
  })
  .get({
    action: 'getAllTvStations',
    property: 'allTvStations',
    path: '/tv-stations/',
    onSuccess: payloadToState('allTvStations')
  })
  .post({
    action: 'createTvStation',
    property: 'tvStation',
    path: '/tv-stations/',
    onSuccess: payloadToState('tvStation')
  })
  .get({
    action: 'getTimezones',
    property: 'timezones',
    path: ({ id }) => `/timezones/`,
    onSuccess: payloadToState('timezones')
  })
  .get({
    action: 'getTvStation',
    property: 'tvStation',
    queryParams: true,
    path: ({ id }) => `/tv-stations/${id}`,
    onSuccess: payloadToState('tvStation')
  })
  .put({
    action: 'updateTvStation',
    property: 'tvStation',
    path: ({ id }) => `/tv-stations/${id}`,
    onSuccess: payloadToState('tvStation')
  })
  .getStore()
